export class ResourceType {
    static readonly story = 'story';
    static readonly comment = 'comment';
    static readonly contribution = 'contribution';
    static readonly user = 'user';
};